import { openBlock as t, createElementBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return t(), n("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M18.125 11c.483 0 .875.336.875.75s-.392.75-.875.75H5.875c-.483 0-.875-.336-.875-.75s.392-.75.875-.75z"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
